// ============================================================
// ORIVA AI — SITE CONFIGURATION
// Edit this single file to update business details, pricing,
// store links, support email and app screenshots.
// No other code changes are needed.
// ============================================================

export const siteConfig = {
  brand: {
    name: "ORIVA AI",
    tagline: "One AI. Three powerful worlds.",
    hindiTagline: "India ka apna AI app",
    // Official ORIVA logo (uploaded asset). Swap the file or path to update.
    logoUrl: "/assets/logo-512.png",
  },

  // DOMAIN: used for canonical/OG metadata. Update this, public/index.html,
  // public/sitemap.xml and public/robots.txt when connecting a custom domain.
  siteUrl: "https://orivaai.co.in",

  founder: {
    name: "Massaid Hussain Shah",
    role: "Founder, ORIVA AI",
  },

  contact: {
    supportEmail: "support@oriva.ai",
    businessName: "ORIVA AI",
    responseTime: "We usually respond within 2–3 business days.",
  },

  links: {
    // Paste the Google Play listing URL when the app is live, e.g.
    // "https://play.google.com/store/apps/details?id=..."
    // Leave empty to show a "coming soon" state instead of a fake link.
    playStoreUrl: "",
  },

  // Update prices or add benefit bullet points at any time.
  // "highlighted" only adds a visual accent to that card.
  pricing: [
    { id: "standard", name: "Standard", priceInr: 199, highlighted: false, benefits: [] },
    { id: "middle", name: "Middle", priceInr: 499, highlighted: false, benefits: [] },
    { id: "ultimate", name: "Ultimate", priceInr: 999, highlighted: true, benefits: [] },
    { id: "ultimate-pro", name: "Ultimate Pro", priceInr: 1899, highlighted: false, benefits: [] },
  ],

  // Real ORIVA app screenshots (uploaded assets). Add more entries to show
  // more phones — the layout adapts automatically.
  appScreenshots: [
    { src: "/assets/app-chat.webp", alt: "ORIVA app — Universal AI Chat" },
    { src: "/assets/app-study-hub.webp", alt: "ORIVA app — Study Hub" },
  ],
};

export default siteConfig;
